<template>
  <!-- 上传记录 author: zhangxiaofeng-->
  <div class="info" id="___info" v-if="errdata">
    <table
      v-if="errdata.bqitem&&errdata.bqitem.length>0"
      width="100%"
      cellspacing="0"
      cellpadding="0"
    >
      <caption>
        {{errdata.title1}}导入详情：{{errdata.title1}}总条数 {{errdata.AllBQCount}}，导入 {{errdata.ImportedBQCount}}条，未导入 {{errdata.UnImportedBQCount}}条
        <a href="javascript:window.print()">打印</a>
      </caption>
      <thead>
        <tr>
          <th width="200">编码</th>
          <th>名称</th>
          <th width="200">未导入原因</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(data,index) in errdata.bqitem" :key="index">
          <td>{{data.code}}</td>
          <td>{{data.name}}</td>
          <td>{{data.result}}</td>
        </tr>
      </tbody>
    </table>

    <table
      v-if="errdata.esti&&errdata.esti.length>0"
      width="100%"
      cellspacing="0"
      cellpadding="0"
      class="esti-table"
    >
      <caption v-if="errdata.AllEstiCount!= 0">
        {{errdata.title2}}导入详情：{{errdata.title2}}总条数 {{errdata.AllEstiCount}}，导入 {{errdata.ImportEstiCount}}条，未导入 {{errdata.UnImportEstiCount}}条
        <a href="javascript:window.print()">打印</a>
      </caption>
      <caption v-else>
        {{errdata.title2}}导入详情：{{errdata.title2}}总条数 {{errdata.AllBQCount}}，导入 {{errdata.ImportedBQCount}}条，未导入 {{errdata.UnImportedBQCount}}条
        <a href="javascript:window.print()">打印</a>
      </caption>
      <thead>
        <tr>
          <th width="200">编码</th>
          <th>名称</th>
          <th width="200">未导入原因</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(data,index) in errdata.esti" :key="index">
          <td>{{data.code}}</td>
          <td>{{data.name}}</td>
          <td>{{data.result}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import UploadHistoryService from '@/assets/service/uploadhistory'
export default {
  name: 'Detail',
  data: () => {
    return {
      errdata: null
    }
  },
  components: {},
  watch: {},
  methods: {
    // 获取错误信息
    queryUploadDetail () {
      let _self = this
      console.log(_self.$route)
      let params = _self.$route.query.uuid
      UploadHistoryService.queryUploadResult(params).then(res => {
        if (+res.code === 200) {
          _self.errdata = JSON.parse(res.data)
          console.log(_self.errdata)
        }
      })
    }
  },
  mounted () {
    this.queryUploadDetail()
  }
}
</script>
<style lang="less" type="text/less" scope>
* {
  margin: 0;
  padding: 0;
}
.info {
  width: 1000px;
  padding: 20px 0;
  margin: 0 auto;
}
table {
  border: 1px solid #ccc;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 14px;
}
caption {
  padding: 8px 5px;
  border: 1px solid #ccc;
  border-bottom: none;
  text-align: left;
  font-size: 20px;
}
caption a {
  color: #1c6ccd;
  text-decoration: none;
  float: right;
}
tr {
  height: 30px;
}
tr:hover td {
  background-color: rgba(243,244,247,1);
}
th,
td {
  padding: 8px 5px;
  border: 1px solid #ccc;
  text-align: left;
}
th {
  background-color: #eee;
  color: #666;
}
</style>
